const importAll = r => r.keys()
  .map(key => key.slice(2)
    .replace('.vue', '').split('/'));

const pages = importAll(require.context('../pages', true, /\.vue$/))

const generateRoute = path => {
  if (path[0].toLowerCase().startsWith('index') && path.length > 1) {
    path.shift()
  }
  if (path.length === 1) {
    const shortcut = path[0].toLowerCase()
    return shortcut.startsWith('index')
      ? ''
      : shortcut.startsWith('_')
        ? shortcut.replace('_', ':')
        : shortcut;
  }
  const lastElement = path[path.length - 1]
  if (lastElement.toLowerCase().startsWith('index')) {
    path.pop()
  } else if (lastElement.startsWith('_')) {
    path[path.length - 1] = lastElement.replace('_', ':');
  }
  return path.map(p => p.toLowerCase()).join('/')
}

const childrenFilter = p => ~p.indexOf('^')

const childrenByPath = pages
  .filter(path => path.some(childrenFilter))
  .map(path => {
    const copy = [...path]
    copy[copy.length - 1] = copy[copy.length - 1].slice(1)
    const key = `/${generateRoute(copy.slice(0, copy.length - 1))}`
    return {
      path,
      route: `/${generateRoute(copy)}`,
      key
    }
  })
  .reduce((acc, cur) => {
    const key = cur.key
    delete cur.key
    if (acc[key]) {
      acc[key].push(cur)
    } else {
      acc[key] = [cur]
    }
    return acc
  }, {})

const defaultLayout = 'default'

export default pages
  .filter(path => !path.some(childrenFilter))
  .map(async path => {
    const { default: component } = await import(`../pages/${path.join('/')}`)
    const { layout, middlewares, name } = component
    const routePublic = generateRoute([...path]).match(/__/g) ? false : true
    const route = `/${generateRoute([...path]).replace('__', '')}`
    let children = []
    if (childrenByPath[route]) {
      const promises = childrenByPath[route].map(async ({ path, route }) => {
        const { default: childComponent } =
          await import(`../pages/${path.join('/')}`)
        const {
          layout: childLayout,
          middlewares: childMiddleware,
          name: childName
        } = childComponent
        return {
          path: route,
          name: childName,
          component: childComponent,
          meta: {
            layout: childLayout || defaultLayout,
            middlewares: childMiddleware || {},
            requireLogin: routePublic,
          }
        }
      })
      children = await Promise.all(promises)
    }
    return {
      path: route,
      name,
      component,
      meta: {
        layout: layout || defaultLayout,
        middlewares: middlewares || {},
        requireLogin: routePublic,
      },
      children
    }
  })
